<cc-list-header-edit
  [index]="index"
  [isLast]="isLast"
  [property]="property"
  (onPropertyMoved)="this.onPropertyMoved.emit($event)"
  (onRequestAddProperty)="this.onRequestAddProperty.emit($event)"
  [editable]="editable"
  (setName)="onPropertyChanged({ name: $event.name })"
  (onPropertyDeleted)="onPropertyDeleted()"
  class="sm-flex sm-justify-between"
>
  <div
    #listExpiry="ngbDropdown"
    ngbDropdown
    (openChange)="onMenuChange($event)"
    dropdownClass="expiry-dropdown"
    class="sm-inline-block"
  >
    <button
      type="button"
      class="expiry-dropdown-toggle-button"
      ngbDropdownToggle
    >
      <i class="cc-icon cc-icon-bell"></i>
    </button>
    <div class="expiry-dropdown-menu" ngbDropdownMenu>
      <cc-list-expiry-notification-management
        [property]="property"
        [users]="users"
        class="d-block"
        (expirySubscription)="onSubscribeDateExpiration($event); listExpiry.close()"
        [menuClosed]="expiryMenuClosed"
        [editable]="editable"
      >
      </cc-list-expiry-notification-management>
    </div>
  </div>
</cc-list-header-edit>
